import { Box } from "@material-ui/core";
import { SirvSpinner } from "../../components/SirvSpinner/SirvSpinner";

export default function LoadingScreen(props) {
  return (
    <Box
      sx={{
        display: "grid",
        width: "100wv",
        height: "100vh",
        alignItems: "center",
        justifyItems: "center",
      }}
    >
      <SirvSpinner />
    </Box>
  );
}
